import { render, staticRenderFns } from "./mediateList.vue?vue&type=template&id=235a28ea&scoped=true&"
import script from "./mediateList.vue?vue&type=script&lang=js&"
export * from "./mediateList.vue?vue&type=script&lang=js&"
import style0 from "./mediateList.vue?vue&type=style&index=0&id=235a28ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235a28ea",
  null
  
)

export default component.exports